// @ts-nocheck
import { CASE_COMMENTS_LIST_ERROR, CASE_COMMENTS_LIST_LOADING, CASE_COMMENTS_LIST_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const CaseCommentsListReducer = (state = initialState, action) => {
    switch (action.type) {
        case CASE_COMMENTS_LIST_LOADING:
            return Object.assign({}, state, { loading: true })
        case CASE_COMMENTS_LIST_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case CASE_COMMENTS_LIST_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

